<template>
  <div class="input-policy-no-dialog">
    <el-dialog
      title="保单号录入"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose">
      <el-form :model="formData" :rules="rules" ref="policyForm" label-width="120px" v-loading="loading">
        <el-form-item label="订单ID：">
          <span>{{ formData.id }}</span>
        </el-form-item>
        
        <el-form-item label="保单号：" prop="policy_no">
          <el-input v-model="formData.policy_no" placeholder="请输入保单号"></el-input>
        </el-form-item>
        
        <el-form-item label="保单文件：">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :before-upload="beforeUpload"
            :file-list="fileList"
            accept=".pdf,.jpg,.jpeg,.png"
            multiple>
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传pdf/jpg/png文件，且不超过10MB</div>
          </el-upload>
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ygbOrderInputPolicyNo } from '@/api/member.js'

export default {
  name: 'InputPolicyNo',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      submitLoading: false,
      formData: {
        id: '',
        policy_no: ''
      },
      rules: {
        policy_no: [
          { required: true, message: '请输入保单号', trigger: 'blur' }
        ]
      },
      fileList: [],
      uploadUrl: process.env.VUE_APP_BASE_API + '/v1/admin/cmn/file/upload',
      uploadHeaders: {
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
        AppKey: 'BpLnfgDs'
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initFormData()
      }
    }
  },
  methods: {
    initFormData() {
      if (this.rowData && Object.keys(this.rowData).length > 0) {
        this.formData = {
          id: this.rowData.id,
          policy_no: this.rowData.policy_no || ''
        }
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit('update:visible', false)
      this.$refs.policyForm.resetFields()
      this.fileList = []
    },
    beforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      return isLt10M;
    },
    handleUploadSuccess(response, file, fileList) {
      if (response && response.err_code === 0) {
        this.$message.success('文件上传成功')
        // 保存文件URL到fileList中
        this.fileList = fileList
      } else {
        this.$message.error(response ? response.err_msg : '文件上传失败')
        // 从fileList中移除失败的文件
        this.fileList = fileList.filter(item => item.uid !== file.uid)
      }
    },
    handleUploadError(err, file, fileList) {
      this.$message.error('文件上传失败: ' + err)
      // 从fileList中移除失败的文件
      this.fileList = fileList.filter(item => item.uid !== file.uid)
    },
    handleSubmit() {
      this.$refs.policyForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          // 获取上传文件的URL
          const policyFileUrls = this.fileList.map(file => file.response ? file.response.data : '').filter(url => url)
          const params = {
            id: this.formData.id,
            policy_no: this.formData.policy_no,
            policy_file: policyFileUrls.join(',')
          }
          
          ygbOrderInputPolicyNo(params).then(response => {
            if (response && response.err_code === 0) {
              this.$message.success('保单号录入成功')
              this.$emit('success')
              this.handleClose()
            } else {
              this.$message.error(response.err_msg || '录入失败')
            }
            this.submitLoading = false
          }).catch(error => {
            console.error('录入失败:', error)
            this.$message.error('录入失败: ' + (error.message || '未知错误'))
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.input-policy-no-dialog {
  /deep/ .el-dialog__body {
    padding: 20px;
  }
  
  .el-form-item {
    margin-bottom: 20px;
  }
  
  .upload-demo {
    /deep/ .el-upload-list__item {
      margin-top: 10px;
    }
  }
}
</style>